'use strict'

import Api from '@/api/analytics.js'

const state = {
  loading: false,
  error: null,
  responsesByStatuses: [],
  pastResponsesByStatuses: []
}

const actions = {
  fetch ({ commit, dispatch }, params) {
    commit('fetch')

    // TODO: Need to change API to isolated method when back will be ready
    return Api.fetchFunnel(params)
      .then(res => commit('fetchSuccess', res))
      .catch(err => {
        dispatch('global/setError', err, { root: true })
        commit('fetchFailure', err)
      })
  },

  fetchCompare ({ commit, dispatch }, params) {
    commit('fetchCompare')

    return Api.fetchFunnel(params)
      .then(res => commit('fetchCompareSuccess', res))
      .catch(err => {
        dispatch('global/setError', err, { root: true })
        commit('fetchCompareFailure', err)
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, res) {
    state.responsesByStatuses = res
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
  },

  fetchCompare (state) {
    state.loading = true
  },

  fetchCompareSuccess (state, res) {
    state.pastResponsesByStatuses = res
    state.loading = false
  },

  fetchCompareFailure (state, err) {
    state.error = err
    state.loading = false
  }
}

const getters = {
  responsesByStatuses: (state) => state.responsesByStatuses,
  pastResponsesByStatuses: (state) => state.pastResponsesByStatuses,
  loading: (state) => state.loading
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
